import { Button, Flex, FormControl, Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import Checkbox from 'react-custom-checkbox';
import { Check } from 'react-feather';
import { skillsArray } from 'utils';

const Skills = ({ next }: { next: () => void }): JSX.Element => {
  const {
    values: { skills },
    setFieldValue,
  } = useFormikContext<ApplicationQuestionsValues>();

  return (
    <Flex direction="column" width="100%">
      <Flex direction="column" bg="custom.levoAlabaster" py="61.5px" px={6}>
        <Text textStyle="heading3" fontWeight="bold">
          What skills/experience do you have? (Select all that apply)
        </Text>
        <FormControl
          id="skills"
          display="flex"
          flexDirection="row"
          gridGap="24px"
          flexWrap="wrap"
          mt={6}
        >
          {skillsArray.map(({ id, key, value }) => (
            <Flex
              key={`skill-${id}`}
              direction="row"
              width={`calc(100%/2 - 12px)`}
            >
              <Checkbox
                checked={!!skills[key]}
                icon={
                  <Flex
                    flex={1}
                    bgColor="#259BE9"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Check size={16} color="white" />
                  </Flex>
                }
                borderColor={!!skills[key] ? '#259BE9' : '#999999'}
                borderRadius={8}
                style={{
                  overflow: 'hidden',
                  borderColor: !!skills[key] ? 'none' : '2px solid #999999',
                  backgroundColor: !!skills[key] ? '#259BE9' : 'white',
                }}
                size={24}
                onChange={(val: boolean) => {
                  const newSkills = { ...skills, [key]: val };
                  setFieldValue('skills', newSkills);
                }}
              />
              <Text ml={4}>{value}</Text>
            </Flex>
          ))}
        </FormControl>
      </Flex>
      <Button
        width="fit-content"
        height="fit-content"
        bg="custom.levoBlue"
        borderRadius="8px"
        mt={6}
        py={4}
        px={6}
        alignSelf="end"
        onClick={next}
      >
        <Text textStyle="body" fontWeight={700} color="white">
          Next
        </Text>
      </Button>
    </Flex>
  );
};

export default Skills;
